// @flow

// Libs
import { createSelector } from 'reselect'
import _find from 'lodash/find'

// Types
import type {
  Asset,
} from 'fc-model-assets/types'

// Selectors
import selectedFieldId$ from './selectedField'
import operation$ from 'hfty-soil-jobs-dom/src/selectors/operation'
import { fieldsOfSelectedFarmAndSeason$ } from 'hfty-assets'

export default createSelector(
  [selectedFieldId$, fieldsOfSelectedFarmAndSeason$, operation$],
  function (selectedField: number, fields: Array<Asset>, operation: Object): Array<Array<number>> {
    if (fields && selectedField) {
      const field = _find(fields, ({id}: number): object => selectedField.id === id)

      if (field) {
        return field
      }
      return null
    }
    return null
  }
)
